
import axios from '../config/axios';

export const url = '/api/gastoporproyectooezl4'


export const customlistadoporproyectoao513_69385435e30724925008ce6b = ({
  proyectoh9v6e,

}) => new Promise((resolve, reject) => {
  if (true) {
    axios.get(`${url}/custom/listado/proyecto`, {
      params: {
        proyectoh9v6e,

      },
      
    }).then((res) => {
      if (res.data.status === 'success') {
        resolve(res.data);
      } else {
        reject(res.data); 
      }
    }).catch((error) => {
      reject(error?.response?.data);
    });
  } else {
    reject({
      status: 'error',
      info: 'Verifique los parametros requeridos',
    });
  }
});



